import api from './request';

/**
 * Get catering items
 */
export const getKioskItems = (params) => {
    return api
        .request("kiosk-items")
        .withParams(params)
        .get();
};

export const hasKioskItems = (params) => {
    return api
        .request("has-kiosk-items")
        .withParams(params)
        .get();
};

export const getKioskCategories = (params) => {
    return api
        .request("kiosk-categories")
        .withParams(params)
        .get();
};

export const getKioskSubCategories = (params) => {
    return api
        .request("kiosk-subcategories")
        .withParams(params)
        .get();
};

/**
 * Checks if catering category has subcategories
 *
 * @param id
 * @return Promise<AxiosResponse<boolean>>
 */
export const hasCateringCategorySubcategories = (id) => {
    return api
        .request(`kiosk-categories/${id}/has-subcategories`)
        .get();
}

/**
 * Returns all items ordered today by consumer
 *
 * @returns Promise<AxiosResponse<any>>
 */
export const getCateringOrderItemsHistory = (data) => {
    return api
        .request("kiosk-order-items/history")
        .withParams(data)
        .get();
};

export const createKioskOrder = (data) => {
    return api
        .request("kiosk-order")
        .withBody(data)
        .post();
};

export const createKioskReturn = (data) => {
    return api
        .request("kiosk-return")
        .withBody(data)
        .post();
};